const setFileUploadURL = data => ({
  type: "SET_URL",
  data
});

export const mutation = {
  setFileUploadURL
};
